import React from 'react';
import { Platform } from 'react-native';

/**
 * Portal — escapes the ancestor stacking context.
 *
 * On web, we mount children at `document.body` via `ReactDOM.createPortal`.
 * That's the only way `position: fixed` reliably anchors to the viewport:
 * any ancestor with `transform`, `filter`, `perspective`, `will-change`, or
 * `contain: paint` becomes the containing block for fixed children, which
 * silently breaks dropdowns rendered inside scrollable / animated panels.
 *
 * On native, there's no CSS containing-block to escape, so we render inline.
 */
export const Portal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	if (Platform.OS === 'web' && typeof document !== 'undefined') {
		const ReactDOM = require('react-dom') as typeof import('react-dom');
		return ReactDOM.createPortal(children, document.body);
	}
	return <>{children}</>;
};
